import $ from 'jquery'
import 'owl.carousel';
import Hypher from 'hypher';
import english from 'hyphenation.en-us';
import "../sass/style.scss"

// Our modules / classes
import Modal from "./modules/Modal"

// Instantiate a new object using our modules/classes
const modal = new Modal()
var header = $('.et-l--header');
var body = $('body');
var mainArea = $('#et-main-area');
header.toggleClass('page-scrolled', $(this).scrollTop() > 1);
body.toggleClass('page-scrolled', $(this).scrollTop() > 1);


$(document).scroll(function () {
 // Detect Page scroll to change navigation //
 header.toggleClass('page-scrolled', $(this).scrollTop() > 100);
 body.toggleClass('page-scrolled', $(this).scrollTop() > 100);
});

$(document).ready(function() {

    // Search icon click functionality
    $('#top-nav-search-icon').on('click', function(e) {
        e.preventDefault();
        $('#top-nav-search').slideDown(300);
    });

    // Close search on click outside or scroll
    $(document).on('click scroll', function(e) {
        if (!$(e.target).closest('#top-nav-search, #top-nav-search-icon').length) {
            $('#top-nav-search').slideUp(300);
        }
    });

    if (typeof window.et_pb_smooth_scroll !== "undefined") {
        window.et_pb_smooth_scroll = function() {}; 
    }

    /// Function to scroll smoothly while accounting for fixed header
    function smoothScroll(target) {
        if (target.length) {
            var headerHeight = $('.et-l--header').outerHeight() || 250; // Adjust for fixed header
            console.log(headerHeight);
            $('html, body').animate({
                scrollTop: target.offset().top - headerHeight
            }, 600, 'swing'); // Adjust duration (600ms) and easing ('swing')
        }
    }

    // Smooth scrolling for anchor links
    $('a[href^="#"]').on('click', function(event) {
        var target = $(this.getAttribute('href'));
        if (target.length) {
            event.preventDefault();
            smoothScroll(target);
        }
    });

    // Smooth scrolling on page load if there's an anchor in the URL
    if (window.location.hash) {
        setTimeout(function() {
            var target = $(window.location.hash);
            smoothScroll(target);
        }, 300);
    }

    // add span around buttons for styling
    if ($('.large-inline-ctas').length) {
        $('.large-inline-ctas a').each(function() {
            $(this).html('<span>' + $(this).html() + '</span>');
        });
    }
    // Find the last .et_pb_section inside #main-content and apply background color to footer ctas
    var lastSection = $('#main-content .et_pb_section').last();

    if (lastSection.hasClass('overflow-behind-ctas')) {
        $('.footer-ctas').css('background-color', 'transparent');

        function updatePadding() {
            // Reset padding-bottom to the computed value from CSS
            lastSection.css('padding-bottom', '');

            // Get the computed padding-bottom from CSS
            var originalPadding = parseInt(lastSection.css('padding-bottom'), 10) || 0;

            // Add the height of .footer-ctas
            var footerHeight = $('.footer-ctas').outerHeight();
            lastSection.css('padding-bottom', `${originalPadding + footerHeight}px`);
        }

        // Initial adjustment
        updatePadding();

        // Observe height changes in .footer-ctas
        if (window.ResizeObserver) {
            var observer = new ResizeObserver(updatePadding);
            observer.observe($('.footer-ctas')[0]);
        }

        // Recalculate on window resize
        $(window).on('resize', updatePadding);
    } else {
        var bgColor = lastSection.css('background-color');
        if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)') {
            $('.footer-ctas').css('background-color', bgColor);
        }
    }

    if ($('.home-banner-button').length) {
        $('.home-banner-button').append('<span></span>');
    }

    if ($('.column-items-slider-full').length ) {
        $('.column-items-slider-full').addClass('owl-carousel');
        $('.column-items-slider-full').owlCarousel({
            nav: true,
            dots: true,
            smartSpeed: 1000,
            items: 1,
            autoplay: false,
            autoplayTimeout: 7000,
            autoplayHoverPause: true,
            loop: true,
            autoHeight: true,
            navText : ["<span class='icon-arrow-left'><span>Prev</span></span>","<span class='icon-arrow-right'><span>Next</span></span>"]
        });
    }

    if ($('.column-items-slider').length ) {
        $('.column-items-slider').addClass('owl-carousel');
        $('.column-items-slider').owlCarousel({
            nav: true,
            dots: true,
            smartSpeed: 1000,
            items: 1,
            autoplay: false,
            autoplayTimeout: 7000,
            autoplayHoverPause: true,
            loop: true,
            autoHeight: true,
            navText : ["<span class='icon-arrow-left'><span>Prev</span></span>","<span class='icon-arrow-right'><span>Next</span></span>"]
        });
    }

    var mainGallery = $('.mu-image-gallery');
    var thumbnailsGallery = $('.mu-image-gallery-nav');

    if (mainGallery.length && thumbnailsGallery.length) {

        thumbnailsGallery.html('');
        mainGallery.find('.et_pb_module img').each(function () {
            var imgSrc = $(this).attr('src');
            var thumbnailHtml = `<div class="item"><img src="${imgSrc}" alt="Thumbnail"></div>`;
            thumbnailsGallery.append(thumbnailHtml);
        });

        mainGallery.addClass('owl-carousel');
        mainGallery.owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            dots: true,
            autoplay: false,
            smartSpeed: 700,
            navText: ["<span class='icon-arrow-left'><span>Prev</span></span>", "<span class='icon-arrow-right'><span>Next</span></span>"]
        }).on('changed.owl.carousel', function (event) {
            var index = event.item.index;

            thumbnailsGallery.find('.owl-item').removeClass('current');
            thumbnailsGallery.find('.owl-item').eq(index).addClass('current');

            thumbnailsGallery.trigger('to.owl.carousel', [index, 300, true]);
        });

        thumbnailsGallery.addClass('owl-carousel');
        thumbnailsGallery.owlCarousel({
            items: 3,
            loop: false,
            nav: false,
            dots: false,
            margin: 10,
            autoplay: false,
            responsive : {
                600 : {
                    items: 5
                }
            }
        });

        thumbnailsGallery.on('click', '.owl-item', function () {
            thumbnailsGallery.find('.owl-item').removeClass('current');
            $(this).addClass('current');
            var index = $(this).index();
            mainGallery.trigger('to.owl.carousel', [index, 300, true]);
        });
    }

    $(window).resize(function() {
        calculateNavHeight();
        if ( $(window).width() < 980 ) {
          startCarousel();
        } else {
          stopCarousel();
        }
    });
    
    function calculateNavHeight() {
      var navHeight = header.height();
      mainArea.css({'padding-top' : navHeight});
    }

    calculateNavHeight()
    
    function startCarousel() {
      if ( $('.mu-mobile-slider-columns').length ) {
        $('.mu-mobile-slider-columns').addClass('owl-carousel');
        $('.mu-mobile-slider-columns').owlCarousel({
            nav: true,
            dots: true,
            items: 1,
            margin: 80,
            autoHeight: true,
            navText: ["<span class='icon-arrow-left'><span>Prev</span></span>", "<span class='icon-arrow-right'><span>Next</span></span>"]
        });
      }
    }
    function stopCarousel() {
      if ( $('.mu-mobile-slider-columns').length ) {
        $('.mu-mobile-slider-columns').removeClass('owl-carousel');
        var owl = $('.mu-mobile-slider-columns');
        owl.trigger('destroy.owl.carousel');
      }
    }

    const hyphenator = new Hypher(english);

    function customHyphenate(word, minCharsBeforeHyphen = 7) {
        if (word.length <= 10) return word;

        const hyphenPoints = hyphenator.hyphenate(word);
        
        const filteredWord = hyphenPoints.reduce((result, part, index) => {
            if (index === 0) return part;
            const previousLength = result.length;
            return previousLength >= minCharsBeforeHyphen ? result + '\u00AD' + part : result + part;
        }, '');
        
        return filteredWord;
    }

    function hyphenateHeadings() {
        const headingsToHyphenate = $('.mu-page-identifier .et_pb_module_heading, .mu-blurb-tile .et_pb_module_header');
        
        headingsToHyphenate.each(function() {
            const $heading = $(this);
            const containerWidth = $heading.width();
            const originalText = $heading.data('original-text') || $heading.text();
            
            // Store original text if not already stored
            if (!$heading.data('original-text')) {
                $heading.data('original-text', originalText);
            }
            console.log(containerWidth);
            if (containerWidth < 500) {
                const words = originalText.split(' ');
                const processedWords = words.map(word => customHyphenate(word));
                const hyphenatedText = processedWords.join(' ');
                $heading.text(hyphenatedText);
            } else {
                // Restore original text if container is wider than 400px
                $heading.text(originalText);
            }
        });
    }
    hyphenateHeadings();

    function checkTabsOverflow() {
        $('.mu-tabs, .mu-tabs-v2').each(function() {
            const $controls = $(this).find('.et_pb_tabs_controls');
            const isOverflowing = $controls[0].scrollWidth > $controls[0].clientWidth;
            $(this).toggleClass('scroll-for-more', isOverflowing);
        });
    }
    checkTabsOverflow();

    function checkTableOverflow() {
        $('table').each(function() {
            const $table = $(this);
            const tableWidth = $table.width();
            const contentWidth = $table.find('tr').first().width();
            
            console.log('Table container width:', tableWidth);
            console.log('Content width:', contentWidth);
            
            const isOverflowing = contentWidth > tableWidth;
            $table.toggleClass('scroll-for-more', isOverflowing);
        });
    }
    checkTableOverflow();

    let resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            hyphenateHeadings();
            checkTabsOverflow();
            checkTableOverflow();
        }, 250);
    });

});
